import { canvasPoint } from '../types'
import { line } from '../utils'

export const TrunkPipeline = (ctx: CanvasRenderingContext2D, start: canvasPoint, end: canvasPoint) => {
  line(ctx, start, end, 3, '#0074BC')
}
